// Libraries
var React = require('react');
var adBlocker = require('just-detect-adblock');

// Styles
require('./AdblockBanner.scss');

class AdblockBannerModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showBanner: false
		};
	}

	handleOpen = () => {
		this.setState({ showBanner: true });
	}

	handleClose = () => {
		sessionStorage.setItem('showAdblockBanner', 'noShow');
		this.setState({ showBanner: false });
	}

	componentDidMount = () => {
		// if detected and if new session or didn't close it
		if(adBlocker.isDetected() && sessionStorage.getItem('showAdblockBanner') === null) {
			this.handleOpen();
		}
	}
	
	render() {
		return (
			<div className="AdblockBanner">
				{this.state.showBanner &&
					<div className="AdblockBanner__wrapper">
						<div className="AdblockBanner__description">
							<p>{this.props.data.descriptionText}</p>
							<p><button onClick={this.handleClose} className="c-button c-button--small">{this.props.data.buttonText}</button></p>
						</div>
					</div>
				}
			</div>
		)
	}
}

module.exports = AdblockBannerModule;



// WEBPACK FOOTER //
// ./src/components/AdblockBanner/AdblockBannerModule.js